import { useNavBarState } from 'app/navBarController';
import { breakpoints, useBreakpoint } from 'app/spacing';
import Logo from 'components/Kizen/Logo';
import { useCallback, useEffect, useState } from 'react';
import { shouldHideNavbarForPath } from 'routes';
import {
  ButtonIcon,
  HeadingWrapper,
  LogoWrapper,
  MobileWrapper,
  Wrapper,
} from './styles';
import { AuthenticatedWithBusiness } from 'routes/auth';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const CustomNavigationWrapper = ({ children }) => {
  const { pathname } = useLocation();
  const hideNav = shouldHideNavbarForPath(pathname);
  const { navBarRef } = useNavBarState();
  const isMobile = useBreakpoint(breakpoints.md);
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const business = useSelector((s) => s.authentication.chosenBusiness);

  const hideKizenLogo = business?.entitlements?.toolbar_logo_suppress ?? false;
  const logoFileId = business?.entitlements?.custom_branding?.app_logo_file_id;
  const customAppName = business?.entitlements?.custom_branding?.product_name;
  const customLogo =
    logoFileId &&
    `${import.meta.env.VITE_API_BASE_PATH}/files/${logoFileId}/download`;

  useEffect(() => {
    if (!isMobile || hideNav) {
      setIsOpen(false);
    }
  }, [isMobile, hideNav]);

  const navigateHome = useCallback(() => {
    history.push('/');
  }, [history]);

  if (hideNav) {
    return null;
  }

  return isMobile ? (
    <MobileWrapper ref={navBarRef}>
      <HeadingWrapper>
        {hideKizenLogo ? null : (
          <LogoWrapper onClick={navigateHome}>
            <Logo customLogo={customLogo} customName={customAppName} />
          </LogoWrapper>
        )}
        <ButtonIcon icon="bars" onClick={() => setIsOpen((open) => !open)} />
      </HeadingWrapper>
      <div>{children(isOpen)}</div>
    </MobileWrapper>
  ) : (
    <Wrapper ref={navBarRef}>
      <div>
        {hideKizenLogo ? null : (
          <LogoWrapper onClick={navigateHome}>
            <Logo customLogo={customLogo} customName={customAppName} />
          </LogoWrapper>
        )}
        {children()}
      </div>
    </Wrapper>
  );
};

export default AuthenticatedWithBusiness(CustomNavigationWrapper);
